type TotpFactor = {
  id: string;
  status?: string;
};

type MfaFactorList = {
  totp?: TotpFactor[];
};

export const MFA_LOCKOUT_ATTEMPTS = 5;
export const MFA_LOCKOUT_WINDOW_MS = 30_000;
export const MFA_SENSITIVE_ACTION_TTL_MS = 5 * 60_000;

export const getPreferredTotpFactor = (factors?: MfaFactorList | null): TotpFactor | null => {
  const totpFactors = factors?.totp ?? [];
  if (!totpFactors.length) {
    return null;
  }

  const verifiedFactor = totpFactors.find((factor) => factor.status === 'verified');
  return verifiedFactor ?? totpFactors[0] ?? null;
};

export const getMfaRequirement = (aalData?: {
  currentLevel?: string | null;
  nextLevel?: string | null;
} | null) => {
  const currentLevel = aalData?.currentLevel ?? null;
  const nextLevel = aalData?.nextLevel ?? null;
  const requiresMfa = currentLevel === 'aal1' && nextLevel === 'aal2';

  return {
    currentLevel,
    nextLevel,
    requiresMfa,
    hasVerifiedAssurance: currentLevel === 'aal2',
  };
};
